function AcademicIntegrity() {
	return (
		<div className="flex flex-col gap-6 text-center py-16">
			<h3 className="header-xl fancy-font">Academic Integrity</h3>
			<p className="text-gray-700 mx-auto max-w-3xl leading-loose">
				We do not condone cheating or plagiarism. Our AI essay writer should be used to inspire essay ideas and
				understand essay structures, not to submit as your own writing. It’s important to integrate your own insights
				and properly cite AI-assisted content. Doing so will ensure your essay remains original and honest.
			</p>
		</div>
	)
}

export default AcademicIntegrity
